import GalleryItem from "../components/GalleryItem";




const Gallery = () => {
    return <>
        <section style={{backgroundColor: "#F3F4F6"}} className="pt-8">
        <h1 className="title-font sm:text-4xl text-3xl text-center font-bold text-black-900">
            Gallery
        </h1>
        </section>
        <GalleryItem
            images={[
            {
                src: "/1-Main-play-area.jpg",
                alt: "Main Play Area",
                caption: "Main Play Area"
            },
            {
                src: "/2-Activity-area.jpg",
                alt: "Activity Area",
                caption: "Activity Area"
            }
            ]}
            backgroundColor="#F3F4F6"
        />
        <GalleryItem
            images={[
            {
                src: "/3-Reading-corner.jpg",
                alt: "Reading Corner",
                caption: "Reading Corner"
            },
            {
                src: "/4-Play-shelf.jpg",
                alt: "Play Shelf",
                caption: "Play Shelf"
            }
            ]}
            backgroundColor="#F3F4F6"
        />
        <GalleryItem
            images={[
            {
                src: "/5-Play-kitchen.jpg",
                alt: "Play Kitchen",
                caption: "Play Kitchen"
            },
            {
                src: "/6-Sleeping-room.jpg",
                alt: "Sleeping Room",
                caption: "Sleeping Room"
            }
            ]}
            backgroundColor="#F3F4F6"
        />
        <GalleryItem
            images={[
            {
                src: "/7-outdoor-play-area.jpg",
                alt: "Outdoor Area",
                caption: "Outdoor Area"
            },
            ]}
            backgroundColor="#F3F4F6"
        />
    </>
}


export default Gallery;